import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ImportOpportunitiesControls } from 'components/underwrite/acquisition/import/importOpportunities';
import { ImportTitlesControls } from 'components/underwrite/acquisition/import/importTitles';
import { LoadingOverlayWrapper } from 'components/layout';
import { ImportStatus } from 'components/underwrite/acquisition/import/importStatus';
import { ImportOpportunityHistoryGrid } from 'components/underwrite/acquisition/import/importOpportunityHistory';
import { RejectedImportsGrid } from 'components/underwrite/acquisition/import/rejectedImports';
import { ImportNav } from 'components/underwrite/shared/import';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { RouteWithTitle } from 'routes';
import { Constants } from 'utilities/constants';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import InfoIcon from '@material-ui/icons/Info';
import HistoryIcon from '@material-ui/icons/History';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import { importModuleStateSelector } from 'store/selectors';

const Import = ({ classes, match, importLoadingOverlayState }) => {
  const [
    opportunityHistoryLoadingState,
    setOpportunityHistoryLoadingState
  ] = React.useState({ isLoading: false, message: null });

  const renderImportOpportunity = () =>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <ImportOpportunitiesControls/>
    </LoadingOverlayWrapper>;

  const renderImportTitles = () =>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <ImportTitlesControls/>
    </LoadingOverlayWrapper>;

  const renderImportOpportunityHistory = () => <>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={opportunityHistoryLoadingState.isLoading}
      message={opportunityHistoryLoadingState.message}
    >
      <ImportOpportunityHistoryGrid
        loading={opportunityHistoryLoadingState}
        setLoading={setOpportunityHistoryLoadingState}
      />
    </LoadingOverlayWrapper>
  </>;

  const renderRejectedImports = () => <>
    <LoadingOverlayWrapper
      className={classes.overlay}
      active={importLoadingOverlayState?.isLoading}
      message={importLoadingOverlayState.message}
    >
      <RejectedImportsGrid/>
    </LoadingOverlayWrapper>
  </>;

  return (
    <div className={classes.root}>
      <ImportNav
        moduleName={Constants.Module.UNDERWRITE}
        pages={[
          { title: 'Opportunity Import', route: Constants.Routes.UNDERWRITE_IMPORT_OPPORTUNITY, icon: <StoreMallDirectoryIcon /> },
          { title: 'Opportunity Import History', route: Constants.Routes.UNDERWRITE_IMPORT_OPPORTUNITY_HISTORY, icon: <HistoryIcon /> },
          { title: 'Rejected Imports', route: Constants.Routes.UNDERWRITE_IMPORT_REJECTED_IMPORTS, icon: <CancelPresentationIcon /> },
          { title: 'Import Status', route: Constants.Routes.UNDERWRITE_IMPORT_STATUS, icon: <InfoIcon /> },
        ]}
      />
      <div className={classes.content}>
        <Switch>
          <RouteWithTitle exact path={Constants.Routes.UNDERWRITE_IMPORT_OPPORTUNITY} title={Constants.RouteTitles.UNDERWRITE_IMPORT_OPPORTUNITY} render={renderImportOpportunity} />
          <RouteWithTitle exact path={Constants.Routes.UNDERWRITE_IMPORT_TITLE} title={Constants.RouteTitles.UNDERWRITE_IMPORT_TITLE} render={renderImportTitles} />
          <RouteWithTitle exact path={Constants.Routes.UNDERWRITE_IMPORT_OPPORTUNITY_HISTORY} title={Constants.RouteTitles.UNDERWRITE_IMPORT_OPPORTUNITY_HISTORY} render={renderImportOpportunityHistory} />
          <RouteWithTitle exact path={Constants.Routes.UNDERWRITE_IMPORT_REJECTED_IMPORTS} title={Constants.RouteTitles.UNDERWRITE_IMPORT_REJECTED_IMPORTS} render={renderRejectedImports} />
          <RouteWithTitle exact path={Constants.Routes.UNDERWRITE_IMPORT_STATUS} title={Constants.RouteTitles.UNDERWRITE_IMPORT_STATUS} component={ImportStatus} />
          <Route
            render={() => {
              return <Redirect to={Constants.Routes.UNDERWRITE_IMPORT_OPPORTUNITY} />; //  /Opportunity is the default route
            }}
          />
        </Switch>
      </div>
    </div>
  );
};

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  content: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    width: 'calc(100vw - (100vw - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  overlay: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  colorPrimary: {
    backgroundColor: 'rgb(189, 189, 189)'
  },
  barColorPrimary: {
    backgroundColor: 'black'
  }
});

const mapStateToProps = state => {
  const underwriteState = importModuleStateSelector(state, Constants.Module.UNDERWRITE);
  return {
    importLoadingOverlayState: underwriteState.importLoadingOverlayState,
  }
}

export default compose(
  withRouter,
  withStyles(styles),
  connect(mapStateToProps, null)
)(Import);
